import { render, staticRenderFns } from "./SectionContents.vue?vue&type=template&id=415b360b&"
import script from "./SectionContents.vue?vue&type=script&lang=js&"
export * from "./SectionContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports